<template>
  <div class="page" v-wechat-title="'推广提现'">
    <div class="extend-top border-box">
      <div class="extend-top-con border-box">
        <div class="top-jrsy">
          <div>
            <p class="p1">今日收益 <span>(元)</span></p>
            <p class="p2">{{today|fixInt}}.<span>{{today|fixFloat}}</span></p>
          </div>
          <div class="btn-agreement" @click="richTxtAlert=1" v-if="richTxt && richTxt.content">提现公告</div>
        </div>
        <div class="top-bot tc clearfix">
          <div class="fl">
            <span>总收益</span>
            <span>{{allmoney}}</span>
          </div>
          <div class="fl">
            <span>账户余额</span>
            <span>{{money}}</span>
          </div>
          <!--<router-link class="extend-account" :to="{path:'/extend-account',query: {id: id}}">立即提现》</router-link>-->
          <p class="extend-account" @click="withdrawal">立即提现》</p>
        </div>
      </div>
    </div>
    <div class="split-line"></div>

    <div class="extend-bot">
      <div class="nav-item border-box">
        推广账户
        <span class="fr">{{phone}}</span>
      </div>
      <div class="nav-item border-box" @click="posterShow=1">
        推广二维码
        <img class="fr" src="../../assets/back.png" alt="">
      </div>
      <div class="nav-item border-box">
        推广链接
        <img class="fr" src="../../assets/back.png" alt="">
        <button type="button" v-clipboard:copy="tgUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制</button>
      </div>
      <p style="clear: both"></p>
      <router-link class="nav-item border-box" :to="{path: '/extend-account', query: {stateCurr: '1', TimeStamp: TimeStamp}}">
        提现榜单
        <img class="fr" src="../../assets/back.png" alt="">
      </router-link>
      <router-link class="nav-item border-box" :to="{path: '/extend-account', query: {stateCurr: '2', TimeStamp: TimeStamp}}">
        收入明细 <img class="fr" src="../../assets/back.png" alt="">
      </router-link>
      <router-link class="nav-item border-box" :to="{path: '/extend-account', query: {stateCurr: '3', TimeStamp: TimeStamp}}">
        提现记录
        <img class="fr" src="../../assets/back.png" alt="">
      </router-link>
    </div>

    <div class="alert-box tx-alert" v-if="txShow">
      <div class="mask"></div>
      <div class="alert-con">
        <img src="../../assets/icon-close.png" class="icon-close" @click="closeTx"/>
        <div class="tx-alert__title">提现</div>
        <div class="alert-info border-box">
          <div class="tx-alert__item money-box">
            <span>提现金额：</span>
            <input type="number" v-model="tx_money" class="input" placeholder="请输入提现金额"/>元
          </div>
          <div class="tx-alert__item radio-box">
            <span>发票选择：</span>
            <!-- <ipnut type="number" /> -->
            <div class="radio-content">
              <div :class="['radio-item',piao==0?'radio-curr':'']" @click="changePiao(0)">
                非发票提现
                <img :src="piao==0?require('../../assets/pay-icon-curr1.png'):require('../../assets/pay-icon.png')"  class="radio-img"/>
              </div>
              <div :class="['radio-item',piao==1?'radio-curr':'']" @click="changePiao(1)">
                发 票 提 现
                <img :src="piao==1?require('../../assets/pay-icon-curr1.png'):require('../../assets/pay-icon.png')" class="radio-img"/>
              </div>
            </div>
            <p class="explain">注意：非发票提现时将扣除提现金额10%作为税费及服务费，请您资讯阅读提现公告！</p>
          </div>
          <div class="tx-piao__item" v-if="piao==1">
            <div class="tx-label">上传发票：</div>
            <div class="piao-content">
              <button class="btn-upload">点击上传<input type="file" class="inputfile" @change="changeFile"/></button>
              <p class="file-name" v-if="filename">{{filename}}</p>
            </div>
          </div>
          <button class="btn-send" @click="confirmTx">提交</button>
        </div>
      </div>
    </div>
    <!--推广二维码弹窗-->
    <AlertPoster  :id="id" :type="'extend'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <!--自定义富文本弹窗-->
    <AlertRichTxtTip @close="closeRichTxtTip" :comeForm="0" :shopname="''" :richTxt="richTxt.content"  v-if="richTxtAlert==1"></AlertRichTxtTip>

  </div>
</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import {getServer} from '@/utils/share'
  import {setStore, getStore, removeStore} from '@/config/mUtils'

  import {getQRcode,getUrl,getIsRegister,basetxnotice2,getAgreement,getActualMoney} from "@/service/getData";
  import {routeUrl,getMoney, wxTX, uploadFile} from '@/utils/wechat'
  import AlertPoster from '../../components/AlertPoster'
  import AlertRichTxtTip from '../../components/AlertRichTxtTip'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  import VueClipboard from 'vue-clipboard2'
  VueClipboard.config.autoSetContainer = true
  Vue.use(VueClipboard)

  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
        id: '', //用户id
        today: '0.00', //今日收益
        allmoney: '0', //总收益
        money: '0', //账户余额
        phone: '', //我的账户

        srcUrl: '', //推广二维码
        tgUrl: '', //推广链接

        isRegister:0,//是否注册
        posterShow:0,//推广二维码弹窗
        shopid:69,

        richTxt: '',//自定义弹窗内容
        richTxtAlert: '',//自定义弹窗内容

        txShow: false, //提现弹框
        tx_money: 0, //提现金额
        piao: 0, //0 非发票提现 1发票提现
        file: '', //file 发票文件地址
        filename: '',//发票文件名称
      }
    },
    computed: {

    },
    created() {
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");

      this.id = this.$route.query.id || "";
      if(this.id){
        this.getBaseData();
        this.getMymoney();
      }else {
        let user =  getStore("user",1) || "";
        if(user && user.user != '' && user.user != null && user.user != undefined){
          this.id = user.user;

          this.getBaseData();
          this.getMymoney();
        }else {
          this.isRegist();
        }
      }

    },

    methods: {

      async isRegist(){
        let res3 = await getIsRegister({
          openid: this.userInfo.openid
        });
        if (res3.errcode == '00000') {
          this.$loading.hide();
          if(res3.data == true){
            this.isRegister = 1; //注册了

            this.$router.push({
              path: `/extend-login`
            });
          }else{
            this.isRegister = 0; //没注册

            this.$router.push({
              path: `/extend-index`
            });
          }
        }
      },

      getMymoney(){
        let self = this;
        getMoney(self.id,function(res){
          console.log(res)
          self.$loading.hide();
          if (res.errcode == "00000") {
            self.today = res.data.today;
            self.allmoney = res.data.allmoney;
            self.money = res.data.money;
            self.phone = res.data.phone;
            console.log(res)
          }
          document.documentElement.scrollTop = document.body.scrollTop = 0;
        });

        this.basetxnotice2Fun()
      },

      //提现公告
      async basetxnotice2Fun(){
        let res3 = await basetxnotice2();
        if (res3.errcode == '00000') {
          //isno  0表示没有公告  1表示有公告    isauto 0表示进入提现页面不自动弹出公告  1表示自动弹出公告
          if( res3.data &&  res3.data.isno){
            this.getAgreementFun()
            if(res3.data.isauto){
              this.richTxtAlert = 1
            }
          }
        }
      },

      //公告内容
      async getAgreementFun(){
        let res3 = await getAgreement({
          id: 14
        });
        if (res3.errcode == '00000') {
          this.richTxt = res3.data.protocol;
        }
      },

      //获取推广二维码，链接
      async getBaseData(){
        let res = await getUrl({
          TimeStamp: this.TimeStamp,
          id: this.id
        });
        if(res.errcode == "00000"){
          this.tgUrl = res.data;
        }
      },

      //提现
      withdrawal(){
        let self = this;
        if (self.money < 1) {
          self.$toast('余额小于一元，不能提现');
          return;
        }
        this.txShow = true;
        // this.$confirm({
        //   title: '提示',
        //   content: '<p><input id="handleNote" type="number" value="'+ self.money +'" placeholder="请输入提现金额" style="padding:.1rem;width:84%;font-size:.26rem;line-height:.36rem;border-radius: .1rem;border: 1px solid #e5e5e5;"></p>',
        //   component: wxConfirm
        // }).then(function(res){
        //   if(res == 'success') {
        //     var val = document.getElementById("handleNote").value;
        //     self.confirmTx(val);
        //   }
        // }).catch(function(res){
        //   if(res == 'success') {
        //     var val = document.getElementById("handleNote").value;
        //     self.confirmTx(val);
        //   }
        // });
      },
      //选择发票提现
      changePiao(val) {
        this.piao = val;
      },
      //选择文件回调
      changeFile(e) {
        let file = e.target.files[0];
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
          this.$toast('上传文件大小不能超过10M')
          return;
        }
        let formData = new FormData();
        formData.append("Filedata", file);
        this.$loading.show('上传中')
        uploadFile(formData, res => {
          this.$loading.hide();
          if (res.errcode === "00000") {
            this.$toast('上传成功');
            this.file = res.data.url;
            this.filename = res.data.name;
          } else {
            this.$toast(res.errmsg)
          }
        })
      },
      //确认提现
      async confirmTx(){
        let self = this;
        var a=/^[0-9]*(\.[0-9]{1,2})?$/;
        if(!a.test(self.tx_money)) {
          self.$toast('请输入正确的金额数字');
          return;
        }
        if (self.tx_money < 1) {
          self.$toast('输入金额不能小于一元');
          return;
        }
        if (self.tx_money > self.money) {
          self.$toast('输入金额不能大于余额');
          return;
        }
        if(self.piao==1&&!self.file) {
          self.$toast('发票提现必须上传发票');
          return
        }
        var obj = {
          openid: this.userInfo.openid,
          type: 1,
          phone: self.phone,
          money: self.tx_money,
          piao: self.piao,
          file: self.file,
        };
        if (self.piao == 0) { // 非发票提现时需要先确认到账金额
          let res = await getActualMoney({money: self.tx_money})
          if (res.errcode === '00000') {
            this.$confirm({
              title: '提示',
              content: '实际到账：' + res.data + '元',
              component: wxConfirm
            }).then(function(res1){
              if(res1 == 'success') {
                self.tx(obj)
              }
            }).catch(function(res1){
              if(res1 == 'success') {
                self.tx(obj)
              }
            });
          } else {
            this.$toast(res.errmsg)
          }
        } else {
          self.tx(obj)
        }
      },
      //提现
      tx(obj) {
        let self = this;
        wxTX(obj,function(data){
            console.log(data)
            if (data.errcode == '00000' || data.errcode == '10000') {
              if (data.errcode == '10000') {
                self.$toast(data.data)
              } else {
                self.$toast('提现成功');
              }
              self.closeTx()
              self.getMymoney();
            } else {
              self.$toast(data.errmsg);
            }
          })
      },
      //关闭提现弹框
      closeTx() {
        this.txShow = false;
        this.piao = 0;
        this.file = '';
        this.tx_money = 0;
        this.filename = '';
      },
      //显示推广二维码弹窗
      showPoster(){
        this.posterShow = 1;
      },
      //关闭推广二维码弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //复制到粘贴板插件
      onCopy(e) {
        this.$toast('复制成功')
      },
      onError(e) {
        this.$toast('复制失败')
      },

      //富文本弹窗
      closeRichTxtTip(msg){
        this.richTxtAlert = msg;
      },

    },
    components: {
      AlertPoster,AlertRichTxtTip
    },
    //格式化数据
    filters: {
      fixInt: function (num) {
        return parseInt(num);
      },
      fixFloat: function (num){
        num = num.toString();
        if(num.indexOf(".") > -1){
          return num.split(".")[1]
        }else {
          return '00'
        }
      }
    }

  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{ background:  #fff; min-height: 100vh; }
  .extend-top{padding:.32rem .08rem .2rem;background: #fff;}
  .extend-top-con{position:relative;width: 100%;height: 3.68rem;padding:.55rem .19rem .23rem .79rem;background: url(../../assets/extend-account-bg.png) no-repeat center;background-size: 100% 100%;}
  .top-jrsy{display: flex; align-items: center;justify-content: space-between;color: #fff;}
  .top-jrsy .p1{font-size: .32rem;}
  .top-jrsy .p1 span{font-size: .22rem;}
  .top-jrsy .p2{margin-top: .08rem;font-size: .64rem;}
  .top-jrsy .p2 span{font-size: .44rem;}
  .top-jrsy .btn-agreement{margin-right: .45rem;width: 1.4rem;height: 0.48rem;text-align: center;font: 0.24rem/0.48rem "Microsoft YaHei";color: #fff;border: 0.01rem solid #fff;border-radius: 0.24rem;}
  .top-bot{position: absolute;bottom: .77rem;left: .79rem;right: .19rem;color: #fff;}
  .top-bot div{margin-right: .34rem;}
  .top-bot div span{display: block;}
  .top-bot div span:first-child{font-size: .26rem;}
  .top-bot div span:last-child{margin-top:.12rem;font-size: .24rem;}
  .extend-account{position: absolute;right:.45rem;bottom: 0;width: 1.4rem;height: .48rem;text-align: center;font:.24rem/.48rem "Microsoft YaHei";color:#fff;border: .01rem solid #fff;-webkit-border-radius: .24rem;border-radius: .24rem;}
  .split-line{width: 100%;height: .3rem;background: #f7f8fa;}
  .nav-item{display:block;width:100%;height: .97rem;line-height: .97rem;padding:0 .4rem;font-size: .28rem;color: #636774;border-bottom: .02rem solid #f7f8fa;}
  .nav-item span.fr{font: .26rem/.97rem "Microsoft YaHei";color: #b9b9bb;}
  .nav-item img.fr{width:auto;height: .18rem;margin-top: .39rem;}
  .nav-item button{ float: right; padding: 0 .1rem; font: .26rem/.97rem "Microsoft YaHei"; color: #b9b9bb; background: none!important; }
  .tx-alert .alert-con{position:absolute;left:.32rem;right:.32rem;top: 50%;padding-bottom:.5rem;border-radius: .16rem;background:#fff;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .tx-alert__title{position: absolute;left: 50%; transform: translateX(-50%);top: .2rem;font-size: .32rem;font-weight: bold;}
  .tx-alert .alert-info{margin-top: .86rem;}
  .tx-alert .btn-send{width:94%;height:.88rem;margin:.32rem 3% 0;font:.36rem/.88rem "Microsoft YaHei";color:#fff;text-align:center;background:#FF9C06;border-radius:.44rem;}
  .tx-alert .tx-alert__item{height: 1.2rem;line-height: 1.20rem;margin: 0 0.24rem;border-bottom: 1px solid #e3e3e3;}
  .tx-alert .tx-alert__item:first-child{border-top: 1px solid #e3e3e3;}
  .tx-alert .tx-alert__item.money-box{display: flex;align-items: center;}
  .tx-alert .tx-alert__item.money-box .input{width: 50%; padding: 0 .12rem; height: .8rem; line-height: .8rem; margin: 0 .12rem; border: 1px solid #ccc; border-radius: .15rem;  }
  .tx-alert .tx-alert__item.radio-box {height: auto;padding-bottom: .4rem;}
  .tx-alert .tx-alert__item .radio-content {display: flex;align-items: center;}
  .tx-alert .tx-alert__item .radio-item {display: flex;align-items: center;height: .8rem;line-height: .8rem; padding: 0 .34rem;margin-right: .4rem; border: 1px solid #e3e3e3;}
  .tx-alert .tx-alert__item .radio-curr{border-color: #3583F0;}
  .tx-alert .tx-alert__item .radio-img{width: .4rem;height: .4rem;margin-left: .2rem;}
  .tx-alert .tx-piao__item{display: flex;align-items: center; margin: 0 0.24rem;border-bottom: 1px solid #e3e3e3;}
  .tx-alert .tx-piao__item .piao-content{flex: 1;}
  .tx-alert .tx-piao__item .btn-upload{position: relative;padding: .16rem .4rem;margin:.2rem 0;border-radius: .12rem;background: #3583F0;color: #fff;}
  .tx-alert .tx-piao__item .inputfile{position: absolute;width: 100%;height: 100%;left: 0;top: 0;opacity: 0;}
  .tx-alert .tx-piao__item .file-name{padding-bottom: .3rem;}
  .tx-alert .explain{line-height: 1.5;margin-top: .2rem;font-size: .24rem;color: #f10;}
</style>



// WEBPACK FOOTER //
// src/page/extend-center/extend-center.vue